import apiClient from './client';

export interface TableStats {
  table_name: string;
  row_count: number;
  total_size: string;
  index_size: string;
  last_vacuum: string | null;
  last_analyze: string | null;
}

export interface ConnectionStats {
  total_connections: number;
  active_connections: number;
  idle_connections: number;
  max_connections: number;
}

export interface DatabaseStats {
  database_size: string;
  tables: TableStats[];
  connections: ConnectionStats;
  cache_hit_ratio: number | null;
}

export interface SlowQuery {
  query: string;
  calls: number;
  total_time_ms: number;
  mean_time_ms: number;
  rows: number;
}

export interface IndexUsage {
  table_name: string;
  index_name: string;
  index_size: string;
  index_scans: number;
  rows_read: number;
  rows_fetched: number;
  usage_ratio: number;
}

export const databaseApi = {
  async getStats(): Promise<DatabaseStats> {
    const response = await apiClient.get<DatabaseStats>('/database/stats');
    return response.data;
  },

  async getSlowQueries(limit = 10): Promise<SlowQuery[]> {
    const response = await apiClient.get<SlowQuery[]>('/database/slow-queries', {
      params: { limit },
    });
    return response.data;
  },

  async getIndexUsage(): Promise<IndexUsage[]> {
    const response = await apiClient.get<IndexUsage[]>('/database/index-usage');
    return response.data;
  },
};
